<script>
import Layout from '@layouts/main.vue'
import { mapActions, mapState } from 'vuex'
import validationMixin from '@components/mixins/validation'

export default {
  page: {
    title: 'Password Change',
    meta: [{ name: 'description', content: 'PasswordChange' }],
  },
  name: 'PasswordChangeView',
  components: { Layout },
  mixins: [validationMixin],
  data() {
    const checkValidPass = (rule, value, callback) => {
      callback(this.validatePass(rule, value, callback))
    }

    const checkValidPass2 = (rule, value, callback) => {
      if (this.passwordChangeForm.new_password1 === this.passwordChangeForm.new_password2) {
        callback(this.validatePass(rule, value, callback))
      } else {
        callback(new Error('Passwords don\'t match'))
      }
    }

    return {
      passwordChangeForm: {
        old_password: '',
        new_password1: '',
        new_password2: '',
      },
      rules: {
        new_password1: [{ validator: checkValidPass }],
        new_password2: [{ validator: checkValidPass2 }],
      },
    }
  },
  computed: {
    allowSetPassword() {
      return this.$store.getters['users/allowSetPassword']
    },
    ...mapState('password', [
      'changeCompleted',
      'changeError',
      'changeErrorMessage',
      'changeLoading',
    ]),
  },
  methods: {
    ...mapActions('password', ['changePassword']),
    formSubmit(form) {
      this.$refs.passwordChangeForm.validate((valid) => {
        if (this.allowSetPassword && this.passwordChangeForm.old_password === '') {
          this.passwordChangeForm.old_password = "none";
        }
        if (valid) {
          this.changePassword(form)
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="flex h-[calc(100vh-90px)]">
      <div class="container">
        <template v-if="changeLoading">
          <Loader></Loader>
        </template>

        <template v-else-if="!changeCompleted">
          <el-form
              ref="passwordChangeForm"
              :model="passwordChangeForm"
              :rules="rules"
              class="c-password-change-form single-column"
              label-width="85px"
              label-position="top"
              status-icon
              @submit.native.prevent>
            <span v-show="changeError" class="e-server-error">
              {{ changeErrorMessage }}
            </span>

            <el-form-item
                v-if="!allowSetPassword"
                class="basic gray"
                label="Current password*"
                prop="old_password">
              <el-input
                  v-model="passwordChangeForm.old_password"
                  type="password"
                  placeholder="••••••••••"></el-input>
            </el-form-item>
            <el-form-item
                class="basic gray"
                label="New password*"
                prop="new_password1">
              <el-input
                  v-model="passwordChangeForm.new_password1"
                  type="password"
                  placeholder="••••••••••"
                  auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item
                class="basic gray"
                label="Confirm new password*"
                prop="new_password2">
              <el-input
                  v-model="passwordChangeForm.new_password2"
                  type="password"
                  placeholder="••••••••••"
                  auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <button class="btn primary"
                      type="button"
                      :disabled="changeLoading"
                      @click="formSubmit(passwordChangeForm)">
                {{ allowSetPassword ? "Set password" : "Change password" }}
              </button>
            </el-form-item>
          </el-form>
        </template>
        <template v-else>
          <div>
            Your password has been changed <b> successfully</b>.
          </div>
        </template>
      </div>
    </div>
  </Layout>
</template>